exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-box[data-v-464679ba] {\n  margin: 12px 0 30px 0;\n  padding: 0 10px;\n}\n.text-ellipsis-2[data-v-464679ba] {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-all;\n  line-height: 1.5;\n  max-height: 3em;\n}\n.copyable[data-v-464679ba] {\n  cursor: pointer;\n  -webkit-transition: color 0.3s;\n  transition: color 0.3s;\n}\n.copyable[data-v-464679ba]:hover {\n  color: #409eff;\n  text-decoration: underline;\n}", ""]);

// exports
